const i = (e, l) => {
  var n;
  return ((n = e == null ? void 0 : e.find(
    (_) => _.language === l && _.value || !e.some((o) => o.language === l && o.value) && _.language === "fi" && _.value
  )) == null ? void 0 : n.value) || null;
}, K = (e) => {
  var n, _, o, s, h, v, g, b, f, w, y, m, x, F, N, $, A;
  const { alcohols: l } = e;
  return l ? !!((n = l[0]) != null && n.percentage_of_alcohol_by_volume) || !!((_ = l[0]) != null && _.sugar_content) || !!((o = l[0]) != null && o.sugar_content_uoms) || !!((s = l[0]) != null && s.sugar_content_uoms[0].value) || !!((h = l[0]) != null && h.degree_of_original_wort) || !!((v = l[0]) != null && v.vintner) || !!((g = l[0]) != null && g.vintage) || !!((b = l[0]) != null && b.subregion) || !!((f = l[0]) != null && f.alcohol_beverage_types[0].value) || !!((w = l[0]) != null && w.alcoholic_beverage_colours[0].value) || !!((y = l[0]) != null && y.sweetness_level_of_alcoholic_beverages[0].value) || !!((m = l[0]) != null && m.alcoholic_beverage_age) || !!((x = l[0]) != null && x.alcoholic_beverage_age_uoms[0].value) || !!((F = l[0]) != null && F.acidity_of_wine_in_grams_per_litre) || !!((N = l[0]) != null && N.tannins[0].value) || !!(($ = l[0]) != null && $.wine_bodies[0].value) || !!((A = l[0]) != null && A.wine_acidities[0].value) : !1;
}, M = (e, l, n) => {
  var _, o, s, h, v, g, b, f, w, y, m, x, F, N, $, A, z, L, S, V, j, k, q, B, C, E, G, H, I, J;
  return [
    {
      condition: !!((_ = e == null ? void 0 : e.alcohols[0]) != null && _.percentage_of_alcohol_by_volume),
      title: l("alcohol_percentage"),
      content: `${Number((o = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : o.percentage_of_alcohol_by_volume).toFixed(1)}%`
    },
    {
      condition: !!((s = e == null ? void 0 : e.alcohols[0]) != null && s.sugar_content) && !!i(
        (h = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : h.sugar_content_uoms,
        n
      ),
      title: l("alcohol_sugar_content"),
      content: `${Number((v = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : v.sugar_content).toFixed(1)}`
    },
    {
      condition: !!((g = e == null ? void 0 : e.alcohols[0]) != null && g.degree_of_original_wort),
      title: l("alcohol_degree_of_wort"),
      content: Number((b = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : b.degree_of_original_wort).toFixed(
        1
      )
    },
    {
      condition: !!((f = e == null ? void 0 : e.alcohols[0]) != null && f.vintner),
      title: l("alcohol_vintner"),
      content: (w = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : w.vintner
    },
    {
      condition: !!((y = e == null ? void 0 : e.alcohols[0]) != null && y.vintage),
      title: l("alcohol_vintage"),
      content: (m = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : m.vintage
    },
    {
      condition: !!((x = e == null ? void 0 : e.alcohols[0]) != null && x.subregion),
      title: l("alcohol_subregion"),
      content: (F = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : F.subregion
    },
    {
      condition: !!i(
        (N = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : N.alcohol_beverage_types,
        n
      ),
      title: l("alcohol_type"),
      content: i(
        ($ = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : $.alcohol_beverage_types,
        n
      )
    },
    {
      condition: !!i(
        (A = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : A.alcoholic_beverage_colours,
        n
      ),
      title: l("alcohol_color"),
      content: i(
        (z = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : z.alcoholic_beverage_colours,
        n
      )
    },
    {
      condition: !!i(
        (L = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : L.sweetness_level_of_alcoholic_beverages,
        n
      ),
      title: l("alcohol_sweetness_level"),
      content: i(
        (S = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : S.sweetness_level_of_alcoholic_beverages,
        n
      )
    },
    {
      condition: !!((V = e == null ? void 0 : e.alcohols[0]) != null && V.alcoholic_beverage_age) && !!i(
        (j = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : j.alcoholic_beverage_age_uoms,
        n
      ),
      title: l("alcohol_age"),
      content: `${Number((k = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : k.alcoholic_beverage_age).toFixed(0)} ${l("alcohol_age_unit")}`
    },
    {
      condition: !!((q = e == null ? void 0 : e.alcohols[0]) != null && q.acidity_of_wine_in_grams_per_litre),
      title: l("alcohol_acidity_per_gram"),
      content: Number(
        (B = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : B.acidity_of_wine_in_grams_per_litre
      ).toFixed(2)
    },
    {
      condition: !!i((C = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : C.tannins, n),
      title: l("alcohol_tannins"),
      content: i((E = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : E.tannins, n)
    },
    {
      condition: !!i(
        (G = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : G.wine_bodies,
        n
      ),
      title: l("alcohol_bodies"),
      content: i((H = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : H.wine_bodies, n)
    },
    {
      condition: !!i(
        (I = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : I.wine_acidities,
        n
      ),
      title: l("alcohol_acidities"),
      content: i(
        (J = e == null ? void 0 : e.alcohols[0]) == null ? void 0 : J.wine_acidities,
        n
      )
    }
  ];
};
export {
  M as getAlcoholSections,
  K as hasAnyAlcoholData
};
